import React from "react";
import { Box, Typography } from "@mui/material";
import Logo from "../Logo/Logo";

export default function LoginHeader() {
    return (
        <Box
            sx={{
                background: "#FFF",
                height: "30vh",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                //minHeight: "22vh",
                justifyContent: "flex-start",
            }}
        >
            <Box
                display={"inline-flex"}
                sx={{
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    margin: "auto",
                }}
            >
                <Logo />
            </Box>
            {/* Bienvenue */}
            <Box
                display="flex"
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    alignSelf: "stretch",
                    margin: "auto",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontSize: 24,
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal",
                        color: "#000",
                    }}
                >
                    Bienvenue !
                </Typography>
            </Box>
        </Box>
    );
}
